// assets/js/alt-stays.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function toggleItem(item, open) {
  const btn = item.querySelector(".alt-stays__trigger");
  const panel = item.querySelector(".alt-stays__panel");
  if (!btn || !panel) return;

  item.classList.toggle("is-open", open);
  btn.setAttribute("aria-expanded", open ? "true" : "false");

  if (open) {
    panel.hidden = false;
    const h = panel.scrollHeight;

    gsap.fromTo(
      panel,
      { height: 0, opacity: 0 },
      {
        height: h,
        opacity: 1,
        duration: 0.35,
        ease: "power2.out",
        onComplete: () => {
          panel.style.height = "";
        },
      },
    );
  } else {
    gsap.to(panel, {
      height: 0,
      opacity: 0,
      duration: 0.28,
      ease: "power2.inOut",
      onComplete: () => {
        panel.hidden = true;
        panel.style.height = "";
      },
    });
  }
}

function initAltStays(section) {
  if (!section || section.__altStaysInit) return;
  section.__altStaysInit = true;

  const items = section.querySelectorAll(".alt-stays__item");
  items.forEach((item) => {
    const btn = item.querySelector(".alt-stays__trigger");
    const panel = item.querySelector(".alt-stays__panel");
    if (!btn || !panel) return;

    const open = item.classList.contains("is-open");
    panel.hidden = !open;

    btn.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");
      toggleItem(item, !isOpen);
    });
  });

  const eyebrow = section.querySelector(".alt-stays__eyebrow");
  const headline = section.querySelector(".alt-stays__headline");
  const intro = section.querySelector(".alt-stays__intro");
  const logos = section.querySelector(".alt-stays__logos");
  const right = section.querySelector(".alt-stays__right");

  gsap.set([eyebrow, headline, intro, logos, right], { opacity: 0, y: 18 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: { trigger: section, start: "top 78%", once: true },
      };

  const tl = gsap.timeline(tlOpts);
  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
  if (headline) tl.to(headline, { opacity: 1, y: 0, duration: 0.65 }, "-=0.2");
  if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.55 }, "-=0.25");
  if (logos) tl.to(logos, { opacity: 1, y: 0, duration: 0.45 }, "-=0.25");
  if (right) tl.to(right, { opacity: 1, y: 0, duration: 0.55 }, "-=0.15");
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".alt-stays").forEach(initAltStays);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".alt-stays").forEach(initAltStays);

  run();
  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
